import React from "react";
import { useParams } from "react-router-dom";
import HubLayout from "../Layout";
import OrderDetails from "../../Order/OrderDetails";

const HubOrderDetails = ({ params }: any) => {
  const route = useParams();

  return (
    <React.Fragment>
      <HubLayout hubId={(route as any)?.hubId as string}>
        <div className="product-list-item-area white-bg">
          <OrderDetails />
        </div>
      </HubLayout>
    </React.Fragment>
  );
};

export default HubOrderDetails;
